import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pipes")({
  beforeLoad: () => {
    throw redirect({
      to: "/pipe-repair-and-replacement-phoenix-az",
      statusCode: 301,
    });
  },
  component: () => null,
});
